import { get } from '../api.js';
import type { LocalStore } from './store.js';

/**
 * My business card on this device (the prototype's "My business card"):
 * kept in the person's encrypted store, so the card and its QR code open
 * at a show without network. Fetched again at each connection.
 */
export interface MyCard {
  firstName: string;
  lastName: string;
  email: string;
  jobTitle: string | null;
  mobile: string | null;
  officePhone: string | null;
  linkedinUrl: string | null;
}

const KEY = 'myCard';

export async function refreshMyCard(store: LocalStore): Promise<MyCard | null> {
  try {
    const info = await get<{
      firstName: string;
      lastName: string;
      email: string;
      card: Omit<MyCard, 'firstName' | 'lastName' | 'email'>;
    }>('/account');
    const card: MyCard = {
      firstName: info.firstName,
      lastName: info.lastName,
      email: info.email,
      ...info.card,
    };
    await store.setMeta(KEY, card);
    return card;
  } catch {
    // Offline or refused: the copy kept stays.
    return null;
  }
}

export function keptMyCard(store: LocalStore): Promise<MyCard | null> {
  return store.getMeta<MyCard>(KEY);
}
